<template>
  <div class="lp-input-container" @click.stop.prevent="clickEl" :style="wrapperStyles" @mouseover.stop.prevent="onHover" @mouseleave.stop.prevent="onLeave">
    <div v-if="deco.type==='text' || deco.type==='email' || deco.type==='phone'" class="input-item">
      <label for="" :style="labelStyles" style="display:block;">{{ data.label }}</label>
      <input type="text" :style="inputStyles"
             @keyup="onKeyup" @blur="chkValid"
             v-model="data.inputData" :placeholder="data.placeholder">
      <div class="lp-error-msg" v-if="errorMsg!==''">{{ errorMsg }}</div>
    </div>
    <div v-else-if="deco.type==='number'" class="input-item">
      <label for="" :style="labelStyles" style="display:block;">{{ data.label }}</label>
      <input type="number" :style="inputStyles" min="1"
             @keyup="onKeyup" @blur="chkValid"
             v-model="data.inputData" :placeholder="data.placeholder">
      <div class="lp-error-msg" v-if="errorMsg!==''">{{ errorMsg }}</div>
    </div>
    <div v-else-if="deco.type==='phone'" class="input-item">
      <label for="" :style="labelStyles" style="display:block;">{{ data.label }}</label>
      <input type="text" :style="inputStyles"
             @keyup="onKeyup" @blur="chkValid"
             v-model="data.inputData" :placeholder="data.placeholder">
      <div class="lp-error-msg" v-if="errorMsg!==''">{{ errorMsg }}</div>
    </div>
    <div v-else-if="deco.type==='password'" class="input-item">
      <label for="" :style="labelStyles" style="display:block;">{{ data.label }}</label>
      <input type="password" :style="inputStyles"
             @keyup="onKeyup" @blur="chkValid"
             v-model="data.inputData" :placeholder="data.placeholder">
      <div class="lp-error-msg" v-if="errorMsg!==''">{{ errorMsg }}</div>
    </div>
    <div v-if="deco.type==='textarea'" class="input-item">
      <span :style="labelStyles" style="display:block;">{{ data.label }}</span>
      <textarea :style="inputStyles"
                @keyup="onKeyup" @blur="chkValid"
                v-model="data.inputData" :placeholder="data.placeholder"></textarea>
      <div class="lp-error-msg" v-if="errorMsg!==''">{{ errorMsg }}</div>
    </div>

    <!--<div v-if="inputSelection" :class="{'lp-selector' : selected }">

      <div class="lp-selector-group" style="width: 125px;">
        <span class="lp-selector-name">입력창</span>
        &lt;!&ndash; 수정 &ndash;&gt;
        <i class="lp-selector-mod material-icons" @click.stop.prevent="clickEl">mode_edit</i>
        &lt;!&ndash; 복사 &ndash;&gt;
        <i class="lp-selector-copy material-icons" @click="$emit('duplicateEl', idx)">content_copy</i>
        &lt;!&ndash; 삭제 &ndash;&gt;
        <i class="lp-selector-del material-icons" @click.stop.prevent="$emit('deleteEl', idx)">delete</i>
      </div>

      &lt;!&ndash; 수정 &ndash;&gt;
      &lt;!&ndash; <i class="lp-selector-mod fa fa-pencil-square-o" aria-hidden="true" @click.stop.prevent="clickEl"></i> &ndash;&gt;
      &lt;!&ndash; 복사 &ndash;&gt;
      &lt;!&ndash; <i class="lp-selector-copy fa fa-clone" aria-hidden="true" @click="$emit('duplicateEl', idx)"></i> &ndash;&gt;
      &lt;!&ndash; 삭제 &ndash;&gt;
      &lt;!&ndash; <i class="lp-selector-del fa fa-trash-o" aria-hidden="true" @click.stop.prevent="$emit('deleteEl', idx)"></i> &ndash;&gt;
    </div>-->
  </div>
</template>

<script>
  import uuidv4 from 'uuid/v4'
  export default {
    props: ['data', 'deco', 'index', 'idx', 'action', 'uid', 'noSelector'],
    data() {
      return {
        //uid: '',
        input: '',
        inputdeco: {},
        selected: false,
        inputSelection: false,
        inputData: '',
        // inputType: "",
        errorMsg: '',
        keyup: false
      }
    },
    destroyed() {
      this.offFuncs(['isSelected', 'isTreeSelected'])
    },
    created() {
      //this.uid = uuidv4();
      this.$root.$emit('createUid',{ type: 'lp-input', uid: this.uid });

      //this.inputData = this.data.val;

      if(this.data.val.search('_!lpdata.update_user.')>-1) {
        let name = this.data.val.split('.')[2];
        let dt = this.$store.getters.user[name];
        if(dt !== undefined) {
          this.data.inputData = dt;
        }
      }


      this.input = this.data;
      this.inputdeco = this.deco;

      this.$root.$on('isSelected', (uid) => {
        if ( this.uid === uid ) {
          this.selected = true;
          this.inputSelection = true;
        }
        else {
          this.selected = false;
          this.inputSelection = false;
        }
      });
      this.$root.$on('isTreeSelected', (uid) => {
        if ( this.uid === uid ) {
          this.selected = true;
          this.inputSelection = true;
          this.clickEl();
        }
        else {
          this.selected = false;
          this.inputSelection = false;
        }
      });
    },
    watch: {
      data(n) {
        this.input = n;
        if(this.data.val.search('_!lpdata.update_user.')>-1) {
          let name = this.data.val.split('.')[2];
          this.inputdata = this.$store.getters.user[name];
        }
      },
      'input.inputData'(n) {
        this.$emit('update:data',this.input);
        this.$emit('onKeyup', n);

        // 폼 post 데이터 store 저장
        if(this.data.val.search('_!lpdata')>-1) {
          this.$store.commit('setFormdata', {
            val: this.data.val,
            inputVal: this.input.inputData
          });
        }
      },
      input(n) {
        this.$emit('update:data', n);
        this.$emit('onKeyup', n);
      },
      deco(n) {
        this.$emit('update:deco', n);
      }
    },
    computed: {
      wrapperStyles() {
        if ( this.deco.wrapper !== undefined ) {
          let deco = this.cloneItem(this.deco.wrapper);

          if ( deco.width !== undefined ) {
            deco.width = this.combineUnit(deco.width);
          }
          if ( deco.height !== undefined ) {
            if ( deco.height.auto ) {
              deco.height = 'auto';
            }
            else if ( !deco.height.auto ) {
              deco.height = deco.height.val + 'px';
            }
          }

          if ( deco.padding !== undefined ) {
            deco.paddingTop = this.combineUnit(deco.padding.top);
            deco.paddingLeft = this.combineUnit(deco.padding.left);
            deco.paddingRight = this.combineUnit(deco.padding.right);
            deco.paddingBottom = this.combineUnit(deco.padding.bottom);
          }
          if ( deco.margin !== undefined ) {
            if ( deco.margin.top.unit === 'auto' ) {
              deco.marginTop = 'auto';
            }
            else {
              deco.marginTop = this.combineUnit(deco.margin.top);
            }
            if ( deco.margin.left.unit === 'auto' ) {
              deco.marginLeft = 'auto';
            }
            else {
              deco.marginLeft = this.combineUnit(deco.margin.left);
            }
            if ( deco.margin.right.unit === 'auto' ) {
              deco.marginRight = 'auto';
            }
            else {
              deco.marginRight = this.combineUnit(deco.margin.right);
            }
            if ( deco.margin.bottom.unit === 'auto' ) {
              deco.marginBottom = 'auto';
            }
            else {
              deco.marginBottom = this.combineUnit(deco.margin.bottom);
            }
          }

          return deco;
        }
      },
      labelStyles() {
        let deco = this.cloneItem(this.deco.label);

        deco.fontSize = this.combineUnit(deco.fontSize);
        deco.fontWeight = deco.fontWeight.val;
        deco.color = this.combineRgba(deco.color);
        deco.backgroundColor = this.combineRgba(deco.backgroundColor);

        deco.width = this.combineUnit(deco.width);

        if ( deco.height !== undefined ) {
          if ( deco.height.auto ) {
            deco.height = 'auto';
          }
          else if ( !deco.height.auto ) {
            deco.height = deco.height.val + 'px';
          }
        }

        deco.paddingTop = this.combineUnit(deco.padding.top);
        deco.paddingLeft = this.combineUnit(deco.padding.left);
        deco.paddingRight = this.combineUnit(deco.padding.right);
        deco.paddingBottom = this.combineUnit(deco.padding.bottom);

        if ( deco.margin.top.unit === 'auto' ) {
          deco.marginTop = 'auto';
        }
        else {
          deco.marginTop = this.combineUnit(deco.margin.top);
        }
        if ( deco.margin.left.unit === 'auto' ) {
          deco.marginLeft = 'auto';
        }
        else {
          deco.marginLeft = this.combineUnit(deco.margin.left);
        }
        if ( deco.margin.right.unit === 'auto' ) {
          deco.marginRight = 'auto';
        }
        else {
          deco.marginRight = this.combineUnit(deco.margin.right);
        }
        if ( deco.margin.bottom.unit === 'auto' ) {
          deco.marginBottom = 'auto';
        }
        else {
          deco.marginBottom = this.combineUnit(deco.margin.bottom);
        }

        deco.borderRadius = deco.borderRadius + 'px';

        deco.borderTop = this.combineUnit(deco.border.top.borderWidth) + ' ' + deco.border.top.borderStyle + ' ' + this.combineRgba(deco.border.top.borderColor.rgba);
        deco.borderLeft = this.combineUnit(deco.border.left.borderWidth) + ' ' + deco.border.left.borderStyle + ' ' + this.combineRgba(deco.border.left.borderColor.rgba);
        deco.borderRight = this.combineUnit(deco.border.right.borderWidth) + ' ' + deco.border.right.borderStyle + ' ' + this.combineRgba(deco.border.right.borderColor.rgba);
        deco.borderBottom = this.combineUnit(deco.border.bottom.borderWidth) + ' ' + deco.border.bottom.borderStyle + ' ' + this.combineRgba(deco.border.bottom.borderColor.rgba);


        if ( deco.fontFamily === '선택안함') {
          deco.fontFamily = '';
        }

        return deco;
      },
      inputStyles() {
        let deco = this.cloneItem(this.deco.input);

        deco.fontSize = this.combineUnit(deco.fontSize);
        deco.fontWeight = deco.fontWeight.val;
        deco.color = this.combineRgba(deco.color);
        deco.backgroundColor = this.combineRgba(deco.backgroundColor);

        deco.width = this.combineUnit(deco.width);

        if ( deco.height !== undefined ) {
          if ( deco.height.auto ) {
            deco.height = 'auto';
          }
          else if ( !deco.height.auto ) {
            deco.height = deco.height.val + 'px';
          }
        }

        deco.paddingTop = this.combineUnit(deco.padding.top);
        deco.paddingLeft = this.combineUnit(deco.padding.left);
        deco.paddingRight = this.combineUnit(deco.padding.right);
        deco.paddingBottom = this.combineUnit(deco.padding.bottom);

        if ( deco.margin.top.unit === 'auto' ) {
          deco.marginTop = 'auto';
        }
        else {
          deco.marginTop = this.combineUnit(deco.margin.top);
        }
        if ( deco.margin.left.unit === 'auto' ) {
          deco.marginLeft = 'auto';
        }
        else {
          deco.marginLeft = this.combineUnit(deco.margin.left);
        }
        if ( deco.margin.right.unit === 'auto' ) {
          deco.marginRight = 'auto';
        }
        else {
          deco.marginRight = this.combineUnit(deco.margin.right);
        }
        if ( deco.margin.bottom.unit === 'auto' ) {
          deco.marginBottom = 'auto';
        }
        else {
          deco.marginBottom = this.combineUnit(deco.margin.bottom);
        }

        deco.borderRadius = deco.borderRadius + 'px';

        deco.borderTop = this.combineUnit(deco.border.top.borderWidth) + ' ' + deco.border.top.borderStyle + ' ' + this.combineRgba(deco.border.top.borderColor.rgba);
        deco.borderLeft = this.combineUnit(deco.border.left.borderWidth) + ' ' + deco.border.left.borderStyle + ' ' + this.combineRgba(deco.border.left.borderColor.rgba);
        deco.borderRight = this.combineUnit(deco.border.right.borderWidth) + ' ' + deco.border.right.borderStyle + ' ' + this.combineRgba(deco.border.right.borderColor.rgba);
        deco.borderBottom = this.combineUnit(deco.border.bottom.borderWidth) + ' ' + deco.border.bottom.borderStyle + ' ' + this.combineRgba(deco.border.bottom.borderColor.rgba);

        if ( deco.fontFamily === '선택안함') {
          deco.fontFamily = '';
        }

        if ( deco.align !== undefined ) {
          if ( deco.align === true ) {
            deco.display = 'block';
            deco.margin = 'auto';
          }
        }

        return deco;
      },
    },
    methods: {
      chkValid() {
        this.errorMsg = this.isValid(this.data, this.deco.type);
      },
      clickEl() {
        if(this.$route.path.search('admin/') === -1) return;
        this.$root.$emit('isSelected', this.uid, this, 'lp-input');
      },
      changeData(prop) {
        this.data = data;
      },
      changeDeco(deco) {
        this.deco = deco;
      },
      onKeyup() {
        if(this.deco.type === 'phone') {
          this.data.inputData = autoHyphenPhone(this.data.inputData);
        }
        /*
        if(this.action.types === 'keyup') {

          if(this.keyup) return;
          this.keyup = true;

          this.$root.$emit('inputData', this.data.inputData);

          this.$axios.get('%s%s?search=%s'.format(backendUrl, this.action.value, this.data.inputData))
            .then(res => {
              this.$store.commit('setPagedata', {
                method_name: this.action.value,
                req_param: '',
                data: res.data
              });
              this.$root.$emit('funcReady');

              setTimeout(res=> {
                this.keyup = false;
              }, 200);
            }).catch(res => {
            this.keyup = false;
          });
        }
        */
      },
      onHover() {
        if(this.$route.path.search('admin/') === -1) return;
        this.inputSelection = true;
        this.selected = true;
        // Selector 비활성화
        if ( this.noSelector === true) {
          this.inputSelection = false;
          this.selected = false;
        }
        // 상위요소 hover 해제
        this.$root.$emit('offSecHover');
        this.$root.$emit('offColHover');
      },
      onLeave() {
        if(this.$route.path.search('admin/') === -1) return;
        if(this.clicked) return;
        this.inputSelection = false;
        this.selected = false;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/ui_main'
  input:focus
    outline none

  .lp-error-msg
    color #e80000
    font-size 0.7rem

</style>

